import { AkcniProdejNd } from './akcniProdejNd';
import { Dodavatel } from './dodavatel';
import { MarketoveSkupinyNd } from './marketoveSkupinyNd';
import { MernaJednotka } from './mernaJednotka';
import { PseudoNahradyNd } from './pseudoNahradyNd';
import { RabatovaSkupina } from './rabatovaSkupina';
import { Sklad } from './sklad';
import { SkladMisto } from './skladoveMisto';
import { SkupinaSlevMaterialu } from './skupinaSlevMaterialu';
import { Slevamat } from './slevamat';
import { ZboziDruh } from './zbozidruh';

export const menu = {
	name: 'CiselnikSkladove',
	list: [
		{ name: 'RabatovaSkupina', route: RabatovaSkupina.name },
		{ name: 'Skladmisto', route: SkladMisto.name },
		{ name: 'SkladyNd', route: Sklad.name },
		{ name: 'MerneJednotky', route: MernaJednotka.name },
		{ name: 'Slevamatsk', route: SkupinaSlevMaterialu.name },
		{ name: 'ZboziDruh', route: ZboziDruh.name },
		{ name: 'Dodavatel', route: Dodavatel.name },
		{ name: 'Slevamat', route: Slevamat.name },
		{ name: 'AkcniProdejNd', route: AkcniProdejNd.name },
		{ name: 'pseudoNahradyNd', route: PseudoNahradyNd.name },
		{ name: 'MarketoveSkupiny', route: MarketoveSkupinyNd.name },
	],
};
